module.exports = __webpack_public_path__ + "img/vertical_1_1_6005.a2550cc5.png";